import React, {Fragment, useEffect, useState} from 'react';
import {t} from 'i18next';
import makeStyles from '@mui/styles/makeStyles';
import {useDispatch, useSelector} from 'react-redux';
import Formatter from '../../../../util/formatter';
import {hasPermission, Permissions, user} from '../../../../store/reducers/user';
import Grid from '@mui/material/Grid';
import AgyleAccordion from '../../../../components/ui/accordion/agyleAccordion';
import Divider from '@mui/material/Divider';
import moment from 'moment/moment';
import Notes from '../../../../util/notes';
import API from '../../../../app/api';
import {capitalizeObjectValues, mapReferralDataToFormStructure} from '../formsUtil';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import {
    ctxPatientPastActivity,
    ctxSplitScreen,
    openSplitScreenWithRegistry,
} from '../../../../store/reducers/patientContext';
import {getConfig} from '../../../../util/configUtil';
import CheckIcon from '@mui/icons-material/Check';
import Tooltip from '@mui/material/Tooltip';
import _ from 'lodash';
import {streamingTypeDict} from '../../../../store/reducers/dicts';

const useStyles = makeStyles((theme) => ({

    divider: {
        width: '100%',
        alignItems: 'center',
        padding: "10px",
        marginBottom: '10px',
    },
    pTitle:{
        color: '#ACAFB3',
        fontSize: '12px',
        fontWeight: '500',

    },
    pTitleRank:{
        color: '#ACAFB3',
        fontSize: '12px',
        fontWeight: '500',
        marginLeft: '25px',
    },
    pData:{
        color: theme.palette.mode === 'light' ? '#878787' : '#FFFFFF',
        //color: '#FFFFFF',
        fontSize: '14px',
        whiteSpace: 'pre-line',
        fontWeight: '500',
    },

    severityBase: {
        display: "flex",
        alignItems: "center",
        height: '24px',
        fontSize: '12px',
        border: '1px',
        borderRadius: "6px",
        padding: '4px 6px 4px 6px',
        gap: '10px',
        justifyContent: 'center',
        width: '66px',
        fontWeight: '500',
    },

    severityMild: {backgroundColor: "#626466",},
    severityModerate: {backgroundColor: "#F7A202",},
    severitySevere: {backgroundColor: "#E25B61",},

    statusBase: {
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: '500',
    },
    statusGreen: {color: "#4EAC6F",},
    statusRed: {color: "#E25B61",},

    dotBase: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        marginRight: "8px",
        fontWeight: '500',
    },
    dotGreen: {backgroundColor: "#4EAC6F",},
    dotRed: {backgroundColor: "#E25B61",},

    secondLabelContainer: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontWeight: '500',
    },

    secondLabelStatusBase:{
        display: "flex",
        alignItems: "center",
        width: 'auto',
        height: '24px',
        fontSize: '12px',
        border: '1px',
        borderRadius: "6px",
        padding: '4px 6px 4px 6px',
        gap: '10px',
        justifyContent: 'center',
        fontWeight: '500',
    },
    secondLabelStatusGreen:{backgroundColor: '#4EAC6F'},
    secondLabelStatusRed:{backgroundColor: '#E25B61'},
    secondLabelItems:{color: '#ACAFB3', backgroundColor: '#494B4C',},

    pDataAcuityScoreBase: {
        padding: '5.4px',
        whiteSpace: 'pre-line',
        display: "flex",
        alignItems: "center",
        width: '27px',
        height: '24px',
        fontSize: '12px',
        border: '1px solid transparent',
        borderRadius: "6px",
        color: 'black',
        justifyContent: 'center',
        fontWeight: '500',
        lineHeight: '1',
        textAlign: 'center',
    },
    pDataAcuityScore1: { backgroundColor: '#DC4A5D'},
    pDataAcuityScore2: { backgroundColor: "#F26B28"},
    pDataAcuityScore3: { backgroundColor: '#f7f700'},
    pDataAcuityScore4: { backgroundColor: '#01AF69'},
    pDataAcuityScore5: { backgroundColor: '#2180F7'},

    gridContainer: {
        position: 'relative',
        fontWeight: '500',
    },

    inlineContainer: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontWeight: '500',
    },
    accordionMandatoryText: {
        marginLeft: 'auto',
        marginRight: '20px',
        fontWeight: '500',
    },
}));


const ReferralReviewForm = (props, id) => {
    const dispatch = useDispatch();

    const classes = useStyles();
    const userObject = useSelector(user);
    const splitScreen = useSelector(ctxSplitScreen);
    const tester = Formatter.formatUserFullName(userObject);
    const [rawData, setRawData] = useState(null);
    const [consents, setConsents] = useState([]);
    const [allergyList, setAllergyList] = useState([]);
    const [medicationsList, setMedicationsList] = useState([]);
    const [activeCount, setActiveCount] = useState(0);
    const [inactiveCount, setInactiveCount] = useState(0);
    const [patientCurrentId, setPatientCurrentId] = useState(null);

    const [referralReviewForm, setReferralReviewForm] = useState(mapReferralDataToFormStructure(null));
    const hasSR = (props) => {
        return props?.patient?.metadata?.patientFlags?.some(item => item.name === 'S&R' && item.checked === true) || false;
    }

    const patientPastActivity = useSelector(ctxPatientPastActivity);

    // Update Patient Demographic
    const registrationEnabled = getConfig('admitPatient.registration', false);
    const canAdmit = dispatch(hasPermission(Permissions.AGYLE_CAN_ADMIT_PATIENT));
    const showUpdate = registrationEnabled && canAdmit;

    const [accordionExpandedState, setAccordionExpandedState] = useState({
        allergyIntolerance: !hasSR(props),
        carePlan: hasSR(props),
        contacts: false,
        consent: false,
        medicationStatement: false,
        observation: false,
        organization: false,
        practitioner: false,
        practitionerRole: false,
        questionnaireResponse: false,
        serviceRequest: false,
    })

    useEffect(() => {

        // if (props.onSubmitFunction) {
        //     props.onSubmitFunction(handleSaveForm);
        // }
        // if (props.onCustomSubmitText) {
        //     props.onCustomSubmitText('Acknowledge');
        // }
        if (props.onHideSubmit) {
            props.onHideSubmit(true);
        }

    }, [referralReviewForm]);

    useEffect(() => {
        if(props?.patient?.metadata?.snReferralId && (patientCurrentId === null || patientCurrentId !== props.patient.id)) {
            setPatientCurrentId(props.patient.id);

            API.getReferralReview(props?.patient.metadata.snReferralId).then((data) => {
                setReferralReviewForm(mapReferralDataToFormStructure(data));
                setRawData(data);
            })
        }
    }, [props.patient]);

    // useEffect(() => {
    //     if(props?.patient) {
    //         API.getReferralReview("APP000128").then((data) => {
    //             setReferralReviewForm(mapReferralDataToFormStructure(data));
    //             setRawData(data);
    //         })
    //     }
    // }, [props.patient]);

    const handleChangeAccordion = (param) => {
        setAccordionExpandedState((pr) =>
            ({
                ...pr,
                [param]:!pr[param]
            }));
    };

    const getSeverityClass = (severity) => {
        switch (severity) {
            case 'Mild':
                return `${classes.severityBase} ${classes.severityMild}`;
            case 'Moderate':
                return `${classes.severityBase} ${classes.severityModerate}`;
            case "Severe":
                return `${classes.severityBase} ${classes.severitySevere}`;
            default:
                return classes.pData;
        }
    };

    const getStatusClasses = (status) => {
        const isGreen = status === 'Active' || status === 'Completed' || status === 'Final';
        const isRed = status === 'Inactive' || status === 'Incompleted';

        return {
            textClass: `${classes.statusBase} ${isGreen ? classes.statusGreen : isRed ? classes.statusRed : classes.pData}`,
            dotClass: `${classes.dotBase} ${isGreen ? classes.dotGreen : isRed ? classes.dotRed : ''}`,
        };
    };

    const outcome = () => {
            const streamingType = useSelector(streamingTypeDict);
            const findService = props.patient?.metadata?.healthcareServiceId ? _.find(streamingType, sr => sr.healthcareService?.includes(props.patient?.metadata?.healthcareServiceId)) : null;
            return findService?.__description || '-';
    }

    const StatusDisplay = ({ status }) => {
        const { textClass, dotClass } = getStatusClasses(status);
        return (
            <div className={textClass}>
                <span className={dotClass}></span>
                {status}
            </div>
        );
    };

    const accordionCarePlanStatus = () => {
        return (
            <StatusDisplay status={referralReviewForm.carePlanStatus} />
        );
    };

    const handleSaveForm = () => {
        const objectToSave = {
            ...referralReviewForm,
            lastUpdateBy: tester,
            lastUpdateDate: moment().toISOString(),
            hasSR: hasSR(props),
        };

        let dataArray = [{
            name: 'referralReviewForm',
            value: objectToSave,

            noteType: 'referralReviewForm',
            noteToAdd: Notes.getReferralReviewNote(objectToSave),
        }];

        props.onChange(dataArray);
    };

    useEffect(() => {
        if (!rawData || typeof rawData !== 'object') return;

        const allergies = Object.keys(rawData)
            .filter(key => key.startsWith('allergyintolerance') && typeof rawData[key] === 'object' && rawData[key] !== null)
            .map(key => {
                const item = rawData[key];
                const status = item?.clinicalStatus?.coding?.[0]?.display?.toLowerCase() || "-";
                return capitalizeObjectValues({
                    allergyIntoleranceFor: item?.code?.coding?.[0].display,
                    verificationStatus: item?.verificationStatus?.coding?.[0]?.display,
                    clinicalStatus: status,
                    lastUpdated: item?.meta?.lastUpdated
                        ? moment(item.meta.lastUpdated).format('DD/MM/YYYY HH:mm')
                        : "-",
                    allergyIntoleranceCategory: item?.category?.[0] || "-",
                    reactionSeverity: item?.reaction?.[0]?.severity || "-",
                    reactionManifestation: item?.reaction?.[0]?.manifestation?.[0]?.coding?.[0]?.display || "-",
                });
            });

        setAllergyList(allergies);

        const active = allergies.filter(a => a.clinicalStatus === "active").length;
        const inactive = allergies.filter(a => a.clinicalStatus === "inactive").length;

        setActiveCount(active);
        setInactiveCount(inactive);
    }, [rawData]);

    const secondLabelAllergyIntolerance = () => {
        return (
            <div className={classes.secondLabelContainer}>
                <div className={`${classes.secondLabelStatusBase} ${classes.secondLabelStatusGreen}`}>
                    Active: {activeCount}
                </div>
                <div className={`${classes.secondLabelStatusBase} ${classes.secondLabelStatusRed}`}>
                    Inactive: {inactiveCount}
                </div>
            </div>
        );
    };

    const renderAllergyIntolerance = () => {
        return allergyList.map((el, index) => (
            <Fragment key={index}>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t("Allergy/Intolerance for")}</p>
                    <p className={classes.pData}>{el.allergyIntoleranceFor}</p>
                </Grid>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t('Clinical Status')}</p>
                    <StatusDisplay status={el.clinicalStatus} />
                </Grid>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t("Last updated")}</p>
                    <p className={classes.pData}>{el.lastUpdated}</p>
                </Grid>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t('Verification status')}</p>
                    <p className={classes.pData}>{el.verificationStatus}</p>
                </Grid>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t('Category')}</p>
                    <p className={classes.pData}>{el.allergyIntoleranceCategory}</p>
                </Grid>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t('Reaction Severity')}</p>
                    <div className={getSeverityClass(el.reactionSeverity)}>
                        {el.reactionSeverity}
                    </div>
                </Grid>

                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t("Reaction Manifestation")}</p>
                    <p className={classes.pData}>{el.reactionManifestation}</p>
                </Grid>
                <Grid item xs={3}/>
            </Fragment>
        ));
    };

    useEffect(() => {
        if (!rawData || typeof rawData !== 'object') return;

        const extracted = Object.keys(rawData)
            .filter((key) => key.startsWith('consent') && typeof rawData[key] === 'object' && rawData[key] !== null)
            .map((key) => capitalizeObjectValues({
                dateTime: rawData[key]?.dateTime || '-',
                status: rawData[key]?.status || "-",
            }));

        setConsents(extracted);
    }, [rawData]);

    const consentsItems = () => {
        return (
            <div className={classes.secondLabelContainer}>
                <div className={`${classes.secondLabelStatusBase} ${classes.secondLabelItems}`}>
                    Items: {consents.length}
                </div>
            </div>
        );
    };

    const renderConsent = () => {
        return consents.map((el, index) => (
            <Fragment key={index}>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t('Date and Time')}</p>
                    <p className={classes.pData}>{el.dateTime}</p>
                </Grid>
                <Grid item xs={3}>
                    <p className={classes.pTitle}>{t('Status')}</p>
                    <p className={classes.pData}>{el.status}</p>
                </Grid>
                <Grid item xs={6}/>
            </Fragment>
        ));
    };

    const renderRejectedService = () => {
        return rawData?.questionnaireresponse?.item?.[0]?.item.map((el, index) => (
            <Fragment key={index}>
                <Grid item xs={splitScreen?.enabled ? 6 : 3}>
                    <p className={classes.pTitle}>{t('Rejected Service Id')}</p>
                    <p className={classes.pData}>{el.item?.[0]?.answer?.[0]?.valueString}</p>
                </Grid>
                <Grid item xs={splitScreen?.enabled ? 6 : 3}>
                    <p className={classes.pTitle}>{t('Rejected Service Name')}</p>
                    <p className={classes.pData}>{el.item?.[1]?.answer?.[0]?.valueString}</p>
                </Grid>
                <Grid item xs={splitScreen?.enabled ? 6 : 3}>
                    <p className={classes.pTitle}>{t('Rejected Service Reason')}</p>
                    <p className={classes.pData}>{el.item?.[2]?.answer?.[0]?.valueCoding?.display}</p>
                </Grid>
                <Grid item xs={splitScreen?.enabled ? 6 : 3}>
                    <p className={classes.pTitle}>{t('Rejected Service Comment')}</p>
                    <p className={classes.pData}>{el.item?.[3]?.answer?.[0]?.valueString}</p>
                </Grid>
                <Divider className={classes.divider} />
            </Fragment>
        ));
    };

    useEffect(() => {
        if (!rawData || typeof rawData !== 'object') return;

        const extracted = Object.keys(rawData)
            .filter((key) => key.startsWith('medicationstatement') && typeof rawData[key] === 'object' && rawData[key] !== null)
            .map((key) => capitalizeObjectValues({
                medicationStatementDateAsserted: rawData[key]?.dateAsserted || "-",
                effectiveDateTime: rawData[key]?.effectiveDateTime || "-",
                medicationStatementCategory: rawData[key]?.category?.coding?.[0]?.display || "-",
                medication: rawData[key]?.medicationCodeableConcept?.coding?.[0]?.display || "-",
                dosage: rawData[key]?.dosage?.[0]?.text || "-",
                dosageRoute: rawData[key]?.dosage?.[0]?.route?.coding?.[0]?.display || "-",
                dosageFrequency: rawData[key]?.dosage?.[0]?.timing?.repeat?.frequency || "-",
                duration: rawData[key]?.dosage?.[0]?.timing?.repeat?.period && rawData[key]?.dosage?.[0]?.timing?.repeat?.periodUnit
                    ? `${rawData[key].dosage?.[0].timing.repeat.period} ${rawData[key].dosage?.[0].timing.repeat.periodUnit}` : "-",
                reasonCode: rawData[key]?.reasonCode?.[0]?.coding?.[0]?.code || "-",
                symptom: rawData[key]?.reasonCode?.[0]?.coding?.[0]?.display || "-",

            }));

        setMedicationsList(extracted);
    }, [rawData]);

    const medicationsItems = () => {
        return (
            <div className={classes.secondLabelContainer}>
                <div className={`${classes.secondLabelStatusBase} ${classes.secondLabelItems}`}>
                    Items: {medicationsList.length}
                </div>
            </div>
        );
    };

    const renderMedications = () => {
        return medicationsList.map((el, index) => (
            <Fragment key={index}>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Date Asserted')}</p>
                    <p className={classes.pData}>{el.medicationStatementDateAsserted}</p>
                </Grid>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Effective Date Time')}</p>
                    <p className={classes.pData}>{el.effectiveDateTime}</p>
                </Grid>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Category')}</p>
                    <p className={classes.pData}>{el.medicationStatementCategory}</p>
                </Grid>
                <Grid item xs={4.8}/>

                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Medication')}</p>
                    <p className={classes.pData}>{el.medication}</p>
                </Grid>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Dosage')}</p>
                    <p className={classes.pData}>{el.dosage}</p>
                </Grid>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Dosage Route')}</p>
                    <p className={classes.pData}>{el.dosageRoute}</p>
                </Grid>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Dosage Frequency')}</p>
                    <p className={classes.pData}>{el.dosageFrequency}</p>
                </Grid>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Duration')}</p>
                    <p className={classes.pData}>{el.duration}</p>
                </Grid>

                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Reason Code')}</p>
                    <p className={classes.pData}>{el.reasonCode}</p>
                </Grid>
                <Grid item xs={2.4}>
                    <p className={classes.pTitle}>{t('Symptom')}</p>
                    <p className={classes.pData}>{el.symptom}</p>
                </Grid>
                <Grid item xs={7.2}/>
            </Fragment>
        ));
    };

    const renderContacts = () => {
        let hasRenderedContactHeader = false;

        return rawData?.patient?.contact?.flatMap((contact, contactIndex) => {
            const hasAnyPositiveOne = contact?.extension?.some(
                (ext) => ext?.valuePositiveInt === 1
            );

            return contact?.telecom?.map((telecom, telecomIndex) => {
                const showHeader = !hasRenderedContactHeader;
                hasRenderedContactHeader = true;
                const isRankOne = telecom?.rank === 1 || telecom?.rank === "1";

                return (
                    <Fragment key={`${contactIndex}-${telecomIndex}`}>
                        <Grid item xs={12}>
                            {showHeader && <h4>{t('Contacts')}</h4>}
                        </Grid>
                        {isRankOne && hasAnyPositiveOne ? (
                            <Grid item xs={0.25}>
                                <p className={classes.pTitle} style={{ visibility: 'hidden' }}>&nbsp;</p>
                                <p className={classes.pData}>
                                    <Tooltip title={t('Primary Contact')}>
                                        <CheckIcon style={{ fontSize: 14 }} />
                                    </Tooltip>
                                </p>
                            </Grid>
                        ) : (
                            <Grid item xs={0.25}>
                                <p className={classes.pTitle} style={{ visibility: 'hidden' }}>&nbsp;</p>
                                <p className={classes.pData}/>
                            </Grid>
                        )}
                        <Grid item xs={splitScreen?.enabled ? 5.5 : 1.75}>
                            <p className={classes.pTitle}>{t('Name')}</p>
                            <p className={classes.pData}>{contact?.name?.family} {contact?.name?.given?.[0] ?? '-'}</p>
                        </Grid>
                        <Grid item xs={splitScreen?.enabled ? 6 : 2}>
                            <p className={classes.pTitle}>{t('Priority order')}</p>
                            <p className={classes.pData}>{telecom?.rank ?? "-"}</p>
                        </Grid>
                        <Grid item xs={splitScreen?.enabled ? 6 : 2}>
                            <p className={classes.pTitle}>{t('Relationship')}</p>
                            <p className={classes.pData}>
                                {contact?.relationship?.[0]?.coding?.[0]?.display ?? "-"}
                            </p>
                        </Grid>
                        <Grid item xs={splitScreen?.enabled ? 6 : 2}>
                            <p className={classes.pTitle}>{t('Contact Method')}</p>
                            <p className={classes.pData}>{telecom?.system ?? "-"}</p>
                        </Grid>
                        <Grid item xs={splitScreen?.enabled ? 6 : 2}>
                            <p className={classes.pTitle}>{t("Contact Details")}</p>
                            <p className={classes.pData}>{telecom?.value ?? "-"}</p>
                        </Grid>
                        <Grid item xs={splitScreen?.enabled ? 6 : 2}>
                            <p className={classes.pTitle}>{t("Contact Status")}</p>
                            <p className={classes.pData}>{telecom?.use ?? "-"}</p>
                        </Grid>

                        <Divider className={classes.divider} />
                    </Fragment>
                );
            })
        });
    };

    const handleEditDemographic = () => {
        dispatch(openSplitScreenWithRegistry(props.patient, true));
    };

    return (
        <>
            {!hasSR(props) &&
                <>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.allergyIntolerance}
                            onChange={()=>handleChangeAccordion("allergyIntolerance")}
                            label="Allergy/Intolerance"
                            //secondLabel={secondLabelAllergyIntolerance}
                            secondHeadingStyle={classes.accordionMandatoryText}
                    >
                        <Grid container spacing={2}>
                            {renderAllergyIntolerance()}
                        </Grid>
                    </AgyleAccordion>
                </>
            }
            <AgyleAccordion className={classes.gridContainer}
                            expanded={accordionExpandedState.carePlan}
                            onChange={()=>handleChangeAccordion("carePlan")}
                            label={"Care Plan"}
                            secondLabel={hasSR(props) ? accordionCarePlanStatus() : null}
                            secondHeadingStyle={hasSR(props) ? classes.accordionMandatoryText : null}
            >
                <Grid container spacing={2}>
                    {!hasSR(props) &&
                        <>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t("Intent")}</p>
                                <p className={classes.pData}>{referralReviewForm.carePlanIntent}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Status')}</p>
                                <StatusDisplay status={referralReviewForm.carePlanStatus} />
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Last updated')}</p>
                                <p className={classes.pData}>{referralReviewForm.carePlanLastUpdated}</p>
                            </Grid>
                            <Grid item xs={3}/>
                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t('Pathways Assessment SD Code')}</p>
                                <p className={classes.pData}>{referralReviewForm.pathwaysAssessmentSDCode}</p>
                            </Grid>
                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t('Pathways Assessment DX Code')}</p>
                                <p className={classes.pData}>{referralReviewForm.pathwaysAssessmentDXCode}</p>
                            </Grid>
                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t('Presenting Complaint - selected Pathway or Template')}</p>
                                <p className={classes.pData}>{referralReviewForm.presentingComplaintselectedPathwayTemplate}</p>
                            </Grid>
                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t('Pathways Assessment SG Code - Chief Complaint')}</p>
                                <p className={classes.pData}>{referralReviewForm.pathwaysAssessmentSGCodeChiefComplaint}</p>
                            </Grid>
                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t('Pathway Assessment')}</p>
                                <p className={classes.pData}>{referralReviewForm.pathwayAssessment}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t("Person expectations and wishes")}</p>
                                <p className={classes.pData}>{referralReviewForm.personExpectationsAndWishes}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t("Safeguarding Concerns Flag")}</p>
                                <p className={classes.pData}>{referralReviewForm.safeguardingConcernsFlag}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t("Additional Information Sources")}</p>
                                <p className={classes.pData}>{referralReviewForm.carePlanAdditionalInformationSources}</p>
                            </Grid>
                            <Grid item xs={3}/>
                        </>
                    }
                    {hasSR(props) &&
                        <>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t("ECDS Acuity Score")}</p>
                                <p className={classes.inlineContainer}>
                                    {referralReviewForm.ecdsAcuityScore && (
                                        <span
                                            className={`${classes.pDataAcuityScoreBase} ${referralReviewForm.ecdsAcuityScore ? classes[`pDataAcuityScore${referralReviewForm.ecdsAcuityScore}`] : ""}`}>
                                            {referralReviewForm.ecdsAcuityScore}
                                        </span>
                                    )}
                                    <span className={classes.pData}>{referralReviewForm.ecdsAcuityScoreTitle}</span>
                                </p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('Period Start')}</p>
                                <p className={classes.pData}>{referralReviewForm.carePeriodStart}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('Last updated')}</p>
                                <p className={classes.pData}>{referralReviewForm.carePlanLastUpdated}</p>
                            </Grid>

                            <Grid item xs={splitScreen?.enabled ? 12 : 4}>
                                <p className={classes.pTitle}>{t('Safeguarding')}</p>
                                <p className={classes.pData}>{referralReviewForm.safeguarding}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t("Attended with")}</p>
                                <p className={classes.pData}>{referralReviewForm.attendedWith}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('OUTCOME')}</p>
                                <p className={classes.pData}>{outcome()}</p>
                            </Grid>

                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('Pathways Assessment SD Code ')}({referralReviewForm.pathwaysAssessmentSDCode})</p>
                                <p className={classes.pData}>{referralReviewForm.pathwaysAssessmentSD}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('Pathways Assessment DX Code ')}({referralReviewForm.pathwaysAssessmentDXCode})</p>
                                <p className={classes.pData}>{referralReviewForm.pathwaysAssessmentDX}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('Pathways Assessment SG Code ')}({referralReviewForm.pathwaysAssessmentSGCodeChiefComplaint})</p>
                                <p className={classes.pData}>{referralReviewForm.pathwaysAssessmentSGChiefComplaint}</p>
                            </Grid>

                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('Presenting Complaint - selected Pathway or Template Code ')}({referralReviewForm.presentingComplaintselectedPathwayTemplateCode})</p>
                                <p className={classes.pData}>{referralReviewForm.presentingComplaintselectedPathwayTemplate}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 4}>
                                <p className={classes.pTitle}>{t('Intent')}</p>
                                <p className={classes.pData}>{referralReviewForm.carePlanIntent}</p>
                            </Grid>

                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t("Pathway Assessment")}</p>
                                <p className={classes.pData}>{referralReviewForm.pathwayAssessment}</p>
                            </Grid>

                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t("Consultation Summary")}</p>
                                <p className={classes.pData}>{referralReviewForm.consultationSummary}</p>
                            </Grid>
                        </>
                    }
                </Grid>
            </AgyleAccordion>
            {hasSR(props) &&
                <>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.contacts}
                                    onChange={()=>handleChangeAccordion("contacts")}
                                    label="Patient information"
                                    secondLabel={showUpdate &&
                                        <AgyleButton
                                            size="small"
                                            colour="primary"
                                            onClick={handleEditDemographic}
                                            disabled={patientPastActivity}
                                        >
                                            {t('Update Demographics')}
                                        </AgyleButton>
                                    }
                                    secondHeadingStyle={classes.accordionMandatoryText}
                    >
                        <Grid container spacing={2}>
                            {renderContacts()}
                            <Grid item xs={splitScreen?.enabled ? 12 : 1.25}>
                                <h4>{t('Patient')}</h4>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 4 : 2}>
                                <p className={classes.pTitle}>{t('REF Number')}</p>
                                <p className={classes.pData}>{referralReviewForm.refNumber}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 4 : 2}>
                                <p className={classes.pTitle}>{t('NHS Number')}</p>
                                <p className={classes.pData}>{referralReviewForm.nhsPatientNumber}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 4 : 2}>
                                <p className={classes.pTitle}>{t('NHS Status')}</p>
                                <p className={classes.pData}>{referralReviewForm.nhsPatientStatus}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 4 : 2}>
                                <p className={classes.pTitle}>{t('Sex at birth')}</p>
                                <p className={classes.pData}>{referralReviewForm.sexAtBirth}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 4 : 2}>
                                <p className={classes.pTitle}>{t('Gender')}</p>
                                <p className={classes.pData}>{referralReviewForm.gender}</p>
                            </Grid>
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.consent}
                                    onChange={()=>handleChangeAccordion("consent")}
                                    label="Patient choice / consent"
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Consent Date')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentDate}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Policy Rule Code')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentPolicyRuleCode}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Policy Rule')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentPolicyRule}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Consent Status')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentRejectedStatus}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Consent Code')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentCode}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Consent Scope')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentScope}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Category Code')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentCategoryCode}</p>
                            </Grid>
                            <Grid item xs={splitScreen?.enabled ? 6 : 1.5}>
                                <p className={classes.pTitle}>{t('Consent Category')}</p>
                                <p className={classes.pData}>{referralReviewForm.consentCategory}</p>
                            </Grid>
                            <Divider className={classes.divider} />
                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t('Rejected Service Date')}</p>
                                <p className={classes.pData}>{referralReviewForm.rejectedServiceDate}</p>
                            </Grid>
                            <Divider className={classes.divider} />
                            {renderRejectedService()}
                        </Grid>
                    </AgyleAccordion>
                </>
            }
            {!hasSR(props) &&
                <>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.consent}
                                    onChange={()=>handleChangeAccordion("consent")}
                                    label="Consent"
                                    secondLabel={consentsItems()}
                                    secondHeadingStyle={classes.accordionMandatoryText}
                    >
                        <Grid container spacing={2}>
                            {renderConsent()}
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.medicationStatement}
                                    onChange={() => handleChangeAccordion('medicationStatement')}
                                    label="Medication Statement"
                                    secondLabel={medicationsItems()}
                                    secondHeadingStyle={classes.accordionMandatoryText}
                    >
                        <Grid container spacing={2}>
                            {renderMedications()}
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.observation}
                                    onChange={()=>handleChangeAccordion("observation")}
                                    label="Observation"
                    >
                        <Grid Grid container spacing={2}>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Date Asserted')}</p>
                                <p className={classes.pData}>{referralReviewForm.observationDateAsserted}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Status')}</p>
                                <StatusDisplay status={referralReviewForm.observationStatus} />
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Expectations and wishes')}</p>
                                <p className={classes.pData}>{referralReviewForm.expectationsAndWishes}</p>
                            </Grid>
                            <Grid item xs={3}/>

                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Note Author')}</p>
                                <p className={classes.pData}>{referralReviewForm.observationNoteAuthor}</p>
                            </Grid>
                            <Grid item xs={9}>
                                <p className={classes.pTitle}>{t('Note')}</p>
                                <p className={classes.pData}>{referralReviewForm.observationNote}</p>
                            </Grid>
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.organization}
                                    onChange={()=>handleChangeAccordion("organization")}
                                    label="Organization"
                    >
                        <Grid Grid container spacing={2}>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Provided By')}</p>
                                <p className={classes.pData}>{referralReviewForm.providedBy}</p>
                            </Grid>
                            <Grid item xs={3}/>
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.practitioner}
                                    onChange={()=>handleChangeAccordion("practitioner")}
                                    label="Practitioner"
                    >
                        <Grid Grid container spacing={2}>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('ID Number')}</p>
                                <p className={classes.pData}>{referralReviewForm.idNumber}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Name')}</p>
                                <p className={classes.pData}>{referralReviewForm.name}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Surname')}</p>
                                <p className={classes.pData}>{referralReviewForm.surname}</p>
                            </Grid>
                            <Grid item xs={3}/>

                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Contact Method')}</p>
                                <p className={classes.pData}>{referralReviewForm.contactMethod}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Contact Type')}</p>
                                <p className={classes.pData}>{referralReviewForm.contactType}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Telephone Number')}</p>
                                <p className={classes.pData}>{referralReviewForm.telephoneNumber}</p>
                            </Grid>
                            <Grid item xs={3}/>
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.practitionerRole}
                                    onChange={()=>handleChangeAccordion("practitionerRole")}
                                    label="Practitioner Role"
                    >
                        <Grid Grid container spacing={2}>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Role')}</p>
                                <p className={classes.pData}>{referralReviewForm.role}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Speciality')}</p>
                                <p className={classes.pData}>{referralReviewForm.speciality}</p>
                            </Grid>
                            <Grid item xs={6}/>
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.questionnaireResponse}
                                    onChange={()=>handleChangeAccordion("questionnaireResponse")}
                                    label="Questionnaire Response"
                    >
                        <Grid Grid container spacing={2}>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Additional Information Sources')}</p>
                                <p className={classes.pData}>{referralReviewForm.questionnaireResponseAdditionalInformationSources}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Additional Sources')}</p>
                                <p className={classes.pData}>{referralReviewForm.additionalSources}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Additional Lookup Sources')}</p>
                                <p className={classes.pData}>{referralReviewForm.additionalLookupSources}</p>
                            </Grid>
                            <Grid item xs={3}/>

                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Source Name')}</p>
                                <p className={classes.pData}>{referralReviewForm.sourceName}</p>
                            </Grid>
                            <Grid item xs={9}>
                                <p className={classes.pTitle}>{t('Source')}</p>
                                <p className={classes.pData}>{referralReviewForm.source}</p>
                            </Grid>

                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Source Name')}</p>
                                <p className={classes.pData}>{referralReviewForm.sourceName2}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('SPN Title')}</p>
                                <p className={classes.pData}>{referralReviewForm.spnTitle}</p>
                            </Grid>
                            <Grid item xs={6}>
                                <p className={classes.pTitle}>{t('SPN Details')}</p>
                                <p className={classes.pData}>{referralReviewForm.spnDetails}</p>
                            </Grid>

                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('SPN Active Date')}</p>
                                <p className={classes.pData}>{referralReviewForm.spnActiveDate}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('SPN Review Date')}</p>
                                <p className={classes.pData}>{referralReviewForm.spnReviewDate}</p>
                            </Grid>
                            <Grid item xs={6}/>
                        </Grid>
                    </AgyleAccordion>
                    <AgyleAccordion className={classes.gridContainer}
                                    expanded={accordionExpandedState.serviceRequest}
                                    onChange={()=>handleChangeAccordion("serviceRequest")}
                                    label="Service Request"
                    >
                        <Grid Grid container spacing={2}>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Intent')}</p>
                                <p className={classes.pData}>{referralReviewForm.serviceRequestIntent}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Status')}</p>
                                <p className={classes.pData}>{referralReviewForm.serviceRequestStatus}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Rejected Services - Details')}</p>
                                <p className={classes.pData}>{referralReviewForm.rejectedServicesDetails}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Rejected Services - Flags')}</p>
                                <p className={classes.pData}>{referralReviewForm.rejectedServicesFlags}</p>
                            </Grid>

                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Category')}</p>
                                <p className={classes.pData}>{referralReviewForm.serviceRequestCategory}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Authored On')}</p>
                                <p className={classes.pData}>{referralReviewForm.authoredOn}</p>
                            </Grid>
                            <Grid item xs={3}>
                                <p className={classes.pTitle}>{t('Occurrence Period')}</p>
                                <p className={classes.pData}>{referralReviewForm.occurrencePeriod}</p>
                            </Grid>
                            <Grid item xs={3}/>

                            <Grid item xs={12}>
                                <p className={classes.pTitle}>{t('Patient Instruction')}</p>
                                <p className={classes.pData}>{referralReviewForm.patientInstruction}</p>
                            </Grid>
                        </Grid>
                    </AgyleAccordion>
                </>
            }
        </>
    )
}

export default ReferralReviewForm;